var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpreadBannerShape = function SvgSpreadBannerShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.145 265c15.645-18.366 42.435-36.416 71.81-49.019l56.63-24.112c.297-.132.595-.248.874-.381 42.993-18.647 68.052-50.592 56.89-71.226L197.218 0c-15.665 18.366-40.966 35.77-70.341 48.39L70.341 72.65C40.947 85.27 15.646 102.676 0 121.04L76.145 265Z"
  })));
};
export default SvgSpreadBannerShape;